module.exports = __webpack_public_path__ + "static/background-5-44e921704c416ee066d9c741dcc83db5.png";